import { render } from "./ChallengeInfos.vue?vue&type=template&id=02eb896b&scoped=true"
import script from "./ChallengeInfos.vue?vue&type=script&lang=js"
export * from "./ChallengeInfos.vue?vue&type=script&lang=js"

import "./ChallengeInfos.vue?vue&type=style&index=0&id=02eb896b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02eb896b"]])

export default __exports__